<template>
    <form class="login login--password-reset" v-bind:action="apiUrl + '/password/reset'" v-on:submit.prevent="handleSubmit">
        <input type="hidden" name="token" v-model="token">

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Your Email') }}</label>
            <span class="jam jam-newsletter is-large"></span>
            <input class="form__control is-large" id="email" type="email" autocomplete="off" placeholder="example@gmail.com"
                   v-model="email"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.password }">
            <label class="form__label" for="password">{{ __('Password') }}</label>
            <span class="jam jam-padlock-open is-large"></span>
            <input class="form__control is-large" id="password" type="password" autocomplete="off"
                   v-bind:placeholder="__('Password')"
                   v-model="password"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.password">{{ errors.password[0] }}</small>

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.confirm_password }">
            <label class="form__label" for="password-confirm">{{ __('Confirm password') }}</label>
            <span class="jam jam-padlock is-large"></span>
            <input class="form__control is-large" id="password-confirm" type="password" autocomplete="off"
                   v-bind:placeholder="__('Confirm password')"
                   v-model="confirmPassword"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.confirm_password">{{ errors.confirm_password[0] }}</small>

        <button class="btn is-primary" type="submit">{{ __('Reset password') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                confirmPassword: '',
                email: '',
                errors: {},
                password: '',
                token: this.$route.params.token || null
            }
        },
        methods: {
            handleSubmit: function (e) {
                eventBus.$emit('show-loader');

                const form = e.target;
                const action = form.getAttribute('action');

                this.$http.post(action, {
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.confirmPassword,
                    token: this.token
                }).then(function (response) {
                    if (response.body.errors) {
                        eventBus.$emit('show-alert', 'error', response.body.errors.message);
                    }
                    else {
                        eventBus.$emit('show-alert', 'success', response.body.message);
                        this.loginUser(response.body.user);
                    }

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PasswordReset.vue